import type { MessageDescriptor } from 'react-intl';

import { aiMessages } from '@atlaskit/editor-common/ai-messages';

import type { StreamingTelepointerIdentity } from '../types/types';

type CreateStreamingTelepointerLabelResolverOptions = {
	formatMessage: (message: MessageDescriptor) => string;
	streamingTelepointerIdentity?: StreamingTelepointerIdentity;
};

type GetStreamingTelepointerLabelOptions = {
	agentName?: string;
	isAgentMentionEnabled: boolean;
};

export const createStreamingTelepointerLabelResolver = ({
	formatMessage,
	streamingTelepointerIdentity = 'rovo',
}: CreateStreamingTelepointerLabelResolverOptions) => {
	const defaultLabel = formatMessage(
		streamingTelepointerIdentity === 'planner'
			? aiMessages.aiPlannerTelepointer
			: aiMessages.aiRovoTelepointer,
	);

	return ({ agentName, isAgentMentionEnabled }: GetStreamingTelepointerLabelOptions): string => {
		return isAgentMentionEnabled && agentName ? agentName : defaultLabel;
	};
};
